module.exports = __webpack_public_path__ + "img/dsci0049.7080dddf.jpg";